var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 23,
    viewBox: "0 0 15 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3727_3525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.75929 7.52839L2.22382 13.3875C2.01481 13.61 1.81254 14.0482 1.77209 14.3516L1.52262 16.5362C1.43497 17.325 2.00133 17.8644 2.78344 17.7296L4.95447 17.3587C5.25788 17.3048 5.68265 17.0823 5.89166 16.8531L11.4271 10.994C12.3845 9.9826 12.8161 8.82966 11.326 7.42051C9.84268 6.02484 8.71671 6.51703 7.75929 7.52839Z",
    stroke: "#0D2C54",
    strokeWidth: 1.61816,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.83691 8.50439C7.12684 10.3653 8.63712 11.7879 10.5115 11.9767",
    stroke: "#0D2C54",
    strokeWidth: 1.61816,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.84082 21.5522H12.9771",
    stroke: "#0D2C54",
    strokeWidth: 1.61816,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3727_3525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.ffc88411ef22e30d588afa4a759faf13.svg";
export { ForwardRef as ReactComponent };